import SuperFetch from "../../../utils/superFetch";

export const registerUser = async (data) => {
    let response = await SuperFetch("/api/send/register", "post", data)
    return response
}

export const getMobileOtp = async (mobileNumber) => {
    let data = {
        mobileNumber
    }
    let response = await SuperFetch('/api/send/otp/mobile', 'post', data)

    return response 
}